import { GetServerSideProps } from 'next'
import { ParsedUrlQuery } from 'querystring'

import { SearchArticleModel } from 'api'
import { PAGE_QUERY_NAME } from 'const/list'
import { articlesServerSidePropsFunc } from 'sections/articles/page-reusable-data/funcs'
import { ArticlesListMain } from 'sections/articles/page-reusable-data/articles'
import { Props } from 'sections/articles/page-reusable-data/articles'

interface Query extends ParsedUrlQuery, Omit<SearchArticleModel, 'page'> {
  [PAGE_QUERY_NAME]?: string
}

export const getServerSideProps: GetServerSideProps<Props, Query> = async (context) => {
  return articlesServerSidePropsFunc(context)
}

export default function ArticlesListPage(props: Props) {
  return <ArticlesListMain data={props} />
}

ArticlesListPage.layoutProps = {}
